export const CRYPTO_KEY = 'e23d1343';
export const CART_ID = 'CART_ID';
export const USER_ID = 'USER_ID';
